import { CheckIcon } from "lucide-react"

import { Image } from "@/components/ui"
import type { SalePropItemProps } from "@/modules/types/jobs/campaign-form"

export function SalePropItem({ item, onChange, propId }: SalePropItemProps) {
  const selected = propId === item?.propValueId?.toString()
  const displayValue = item?.propValue === "Default" ? "Mặc định" : item?.propValue

  return (
    <button
      type="button"
      onClick={() => onChange(item?.propValueId?.toString())}
      className={`relative flex flex-col items-center rounded-lg border p-2 w-24 h-28 ${
        selected ? "border-primary" : "border-gray-300"
      }`}
    >
      {!!item?.image && (
        <Image src={item.image} alt="sku" className="h-16 w-16 rounded-md object-cover" />
      )}
      <span className="mt-1 text-xs text-center truncate w-full">{displayValue}</span>
      {selected && <CheckIcon className="absolute top-1 right-1 h-4 w-4 text-primary" />}
    </button>
  )
}
